export const CheckoutRoute = {
  LAYOUT: {
    name: 'checkout-layout',
    path: '/'
  },
  CHECKOUT: {
    name: 'checkout',
    path: '/checkout'
  },
  CHECKOUT_SUCCESS: {
    name: 'checkout-success',
    path: 'checkout/success'
  }
};
